const request = {
    invalid_input: 'Input inválido. {{details}}',
    general: 'Ocorreu um erro no pedido.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
};
export default Object.freeze(request);
